//params 数据放到请求 params中
interface contentResObject {
  msg?: string;
  status?: number;
  data?: any;
}
export const ApiFacebookLogin = (params: any) => {
  return new Promise((resolve, reject) => {
    onRequest('post', '/login-url/rest/member/thirdlogin', params)
      .then((data: any) => {
        let res = data.data._value;
        if (res.status == 0) {
          resolve(res.data);
        }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
export const ApiGuestLogin = () => {
  return new Promise((resolve, reject) => {
    onRequest('post', '/login-url/rest/member/guestlogin')
      .then((data: any) => {
        let res = data.data._value;
        if (res.status == 0) {
          resolve(res.data);
        }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
// 会员退出登录
export const ApiMemberLogout = () => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/login-url/rest/member/logout')
      .then((data: any) => {
        let res = data.data._value;
        resolve(res.status);
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
export const ApiGetOrder = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/login-url/rest/order/list', params)
      .then((data: any) => {
        let res = data.data._value;
        resolve(res);
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
export const ApiGetMemberInfo = () => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/login-url/rest/member/memberInfo')
      .then((data: any) => {
        let res = data.data._value;
        resolve(res);
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
export const ApiGetMemberFamilyList = () => {
  return new Promise((resolve, reject) => {
    onRequest('post', '/login-url/rest/freqcontact/ffList')
      .then((data: any) => {
        let res = data.data._value;
        resolve(res);
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
export const ApiGetMemberFamilyInfo = (params: Object) => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/login-url/rest/freqcontact/ffInfo', params)
      .then((data: any) => {
        let res = data.data._value;
        if (res.status == 0) {
          resolve(res.data);
        }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
// 保存当前会员信息
export const ApiSaveMemberInfo = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('post', '/login-url/rest/member/saveMemberInfo', params)
      .then((data: any) => {
        let res = data.data._value;
        resolve(res.status);
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
// 保存常用联系人信息
export const ApiSaveFreqcontactInfo = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('post', '/login-url/rest/freqcontact/ffSave', params)
      .then((data: any) => {
        let res = data.data._value;
        resolve(res.status);
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
// 删除常用联系人信息

export const ApiDelFreqcontactInfo = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/login-url/rest/freqcontact/ffDelete', params)
      .then((data: any) => {
        let res = data.data._value;
        resolve(res.status);
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
export const ApiGetOrderDetail = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('post', '/login-url/rest/order/get', params)
      .then((data: any) => {
        let res = data.data._value;
        if (res.status == 0) {
          resolve(res.data);
        }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
// 会员注册
export const ApiMemberRegister = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('post', '/login-url/rest/member/register', params)
      .then((data: any) => {
        let res = data.data._value;
        resolve(res);
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
// 会员登录
export const ApiMemberLogin = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('post', '/login-url/rest/member/login', params)
      .then((data: any) => {
        let res = data.data._value;
        resolve(res);
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
// 联系我们
export const ApiContactUsSubject = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('post', '/login-url/rest/contactus/save', params)
      .then((data: any) => {
        let res = data.data._value;
        resolve(res);
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
